/**
 * Portal.jsx
 *
 * @Author: jruif
 * @Date: 2018/1/8 上午10:17
 */

import React from 'react';
import ReactDOM from 'react-dom';

function ownerDocument(node) {
  return (node && node.ownerDocument) || document;
}

function getOwnerDocument(element) {
  return ownerDocument(ReactDOM.findDOMNode(element));
}

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return ReactDOM.findDOMNode(container) || defaultContainer;
}

/**
 * @ignore
 */
class Portal extends React.PureComponent {
  componentDidMount() {
    const { container, disablePortal, onRendered } = this.props;
    this.setMountNode(container);

    // Only rerender if needed
    if (!disablePortal) {
      this.forceUpdate(onRendered);
    }
  }

  componentDidUpdate(prevProps) {
    const { container, disablePortal, onRendered } = this.props;
    if (prevProps.container !== container || prevProps.disablePortal !== disablePortal) {
      this.setMountNode(container);

      // Only rerender if needed
      if (!disablePortal) {
        this.forceUpdate(() => {
          if (onRendered) {
            // This might be triggered earlier than the componentDidUpdate of a parent element.
            // We need to account for it.
            clearTimeout(this.renderedTimer);
            this.renderedTimer = setTimeout(onRendered);
          }
        });
      }
    }
  }

  componentWillUnmount() {
    this.mountNode = null;
    clearTimeout(this.renderedTimer);
  }

  setMountNode(container) {
    const { disablePortal } = this.props;
    if (disablePortal) {
      this.mountNode = ReactDOM.findDOMNode(this).parentElement;
      return;
    }
    this.mountNode = getContainer(container, getOwnerDocument(this).body);
  }

  getMountNode = () => this.mountNode;

  render() {
    const { children, disablePortal } = this.props;

    if (disablePortal) {
      return children;
    }
    return this.mountNode ? ReactDOM.createPortal(children, this.mountNode) : null;
  }
}

export default Portal;



// WEBPACK FOOTER //
// ./src/portal/Portal.jsx